import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'hrra-jobseeker-location',
    templateUrl: './jobseeker-location.component.html',
    styleUrls: ['./jobseeker-location.component.scss'],
    standalone: false
})
export class JobseekerLocationComponent implements OnInit {

  @Input() locations: string[];

  constructor() { }

  ngOnInit(): void {
  }

}
